module.exports = __webpack_public_path__ + "static/media/homepage-section-2-offices.4d21ea30.png";